import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {
  FaArrowRight,
  FaAward,
  FaBuilding,
  FaCalendarCheck,
  FaChevronLeft,
  FaChevronRight,
  FaHome,
  FaShieldAlt,
  FaUsers,
} from "react-icons/fa";

import "./swiper.css";

import img1 from "../../images/fl1.jpg";
import img2 from "../../images/Fl2.jpg";
import img3 from "../../images/h2.jpeg";
import img4 from "../../images/h3.jpeg";
import img9 from "../../images/wk1.jpg";
import img11 from "../../images/wk3.jpg";

const projects = [
  {
    id: 1,
    src: img1,
    // alt: "Luxury residential house",
    title: "Apartment",
    meta: "Modern • Elegant • Timeless",
    icon: FaHome,
  },
  {
    id: 2,
    src: img2,
    // alt: "Premium apartment project",
    title: "Premium Apartment",
    meta: "Comfort • Style • Community",
    icon: FaBuilding,
  },
  {
    id: 3,
    src: img3,
    // alt: "Modern house project",
    title: "Modern House",
    meta: "Architecture • Comfort • Luxury",
    icon: FaHome,
  },
  {
    id: 4,
    src: img4,
    // alt: "Contemporary villa project",
    title: "Signature Villa",
    meta: "Design • Detail • Distinction",
    icon: FaHome,
  },
  {
    id: 5,
    src: img9,
    alt: "Commercial studio project",
    title: "Commercial Space",
    meta: "Planning • Utility • Presence",
    icon: FaBuilding,
  },
  {
    id: 6,
    src: img11,
    // alt: "Retail building project",
    title: "Retail Project",
    meta: "Smart • Functional • Durable",
    icon: FaBuilding,
  },
];

const highlights = [
  {
    icon: FaShieldAlt,
    title: "Quality Construction",
    text: "Built with fine materials and trusted standards.",
  },
  {
    icon: FaUsers,
    title: "Expert Team",
    text: "Skilled professionals delivering practical solutions.",
  },
  {
    icon: FaCalendarCheck,
    title: "On-Time Delivery",
    text: "Committed to planned milestones and schedules.",
  },
  {
    icon: FaAward,
    title: "Customer Satisfaction",
    text: "Long-term relationships shaped by transparency.",
  },
];

const PortfolioArrow = ({ className, onClick, direction }) => {
  const Icon = direction === "prev" ? FaChevronLeft : FaChevronRight;

  return (
    <button
      className={`${className || ""} portfolio-arrow portfolio-arrow--${direction}`}
      type="button"
      onClick={onClick}
      aria-label={direction === "prev" ? "Previous project" : "Next project"}
    >
      <Icon />
    </button>
  );
};

const CarouselPage = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 650,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3600,
    centerMode: true,
    centerPadding: "28px",
    prevArrow: <PortfolioArrow direction="prev" />,
    nextArrow: <PortfolioArrow direction="next" />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          centerMode: false,
          centerPadding: "0px",
        },
      },
      {
        breakpoint: 700,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          arrows: false,
        },
      },
    ],
  };

  return (
    <section className="portfolio-section" aria-labelledby="portfolio-title">

      
      <div className="portfolio-heading">
        <span className="portfolio-kicker">Our Portfolio</span>
        <h2 id="portfolio-title">
          Crafting <span>Spaces</span>, Building Trust
        </h2>
        <p>
          Explore our diverse portfolio of residential and commercial projects
          designed with excellence and delivered with pride.
        </p>
      </div>

      <div className="portfolio-slider-wrap">
        <Slider {...settings}>
          {projects.map((project) => {
            const Icon = project.icon;

            return (
              <article className="portfolio-slide" key={project.id}>
                <div className="portfolio-card">
                  <div className="portfolio-card__image">
                    <img src={project.src} alt={project.alt} />
                  </div>
                  <div className="portfolio-card__content">
                    <span className="portfolio-card__icon">
                      <Icon />
                    </span>
                    <div className="portfolio-card__copy">
                      <h3>{project.title}</h3>
                      {/* <p>{project.meta}</p> */}
                    </div>
                    <span className="portfolio-card__arrow" aria-hidden="true">
                      <FaArrowRight />
                    </span>
                  </div>
                </div>
              </article>
            );
          })}
        </Slider>
      </div>

      
    </section>
  );
};

export default CarouselPage;
